import { createContext, useContext } from 'react';

import type { ILead, Notification, UserSettings } from 'src/services/api';
import type { IUser } from 'src/api/users-api';
import type { IAchievement, IUserAchievement } from 'src/api/achievements';

type IAuthenticatedState = {
    loggedInUser: IUser;
    userSettings: UserSettings;

    leads: ILead[];
    leadsByUuid: Map<string, ILead>;
    leadIngestionSources: string[];

    notifications: Notification[];
    achievements: { achievements: IAchievement[]; user_achievements: IUserAchievement[] };

    isPaywallEnabled: boolean;

    isInactivePropertiesModalOpen: boolean;
    setIsInactivePropertiesModalClosed: (value: boolean) => void;

    isLoading: boolean;
};

// @ts-expect-error lazy init
export const AuthenticatedStateContext = createContext<IAuthenticatedState>();

export const useAuthenticatedState = () => {
    const context = useContext(AuthenticatedStateContext);

    if (!context) {
        throw new Error('useAuthenticatedState must be used within an AuthenticatedStateProvider');
    }
    return context;
};
